/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WeightInputs */

const en_weight = /** @type {(inputs: WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const es_weight = /** @type {(inputs: WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

/**
* | output |
* | --- |
* | "Weight" |
*
* @param {WeightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const weight = /** @type {((inputs?: WeightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WeightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weight(inputs)
	return es_weight(inputs)
});